import Tenant from 'models/tenant';

//
// An org unit is "external" (linked to a separate Microsoft Entra directory) when its Azure directory differs from its
// top-level parent's. The top-level's Azure tenant id is resolved from the login tenant list (appContext.user.login.tenants).
// Requires the org unit object to carry azureTenantId + topLevelParentTenantId (the org-units list now includes both).
//
export function orgUnitHasSeparateEntra(orgUnit: Tenant, loginTenants: Tenant[]): boolean {
  const topLevelAzureTenantId = loginTenants.find((tn) => tn.id === orgUnit.topLevelParentTenantId)?.azureTenantId;

  return !!orgUnit.azureTenantId && !!topLevelAzureTenantId && orgUnit.azureTenantId !== topLevelAzureTenantId;
}
